module.exports = __webpack_public_path__ + "static/media/fourth_first_bank.c46a3682.mp4";